// extracted by mini-css-extract-plugin
export default {"add_client_btn":"AddButton_add_client_btn__Mkuvw","addicon":"AddButton_addicon__OWKCx","text_wrapper":"AddButton_text_wrapper__4Gjoi"};